import { Component, computed, EventEmitter, input, Input, model, Output } from '@angular/core';
import { Menu } from 'primeng/menu';
import { NgClass } from '@angular/common';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { NOT_IMPORTANT_TABLE_HEADER } from '../../../../../../models/interfaces';
import { FieldModelKey } from '../../../../../../models/extraction-models/extraction-models';
import { TableData } from '../../../../../../table-overlay/table-overlay';
import { entries } from '@ps-gui/shared-utils';
import { FloatingElementDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'ct-extraction-table-overlay-column-assignment-item',
  imports: [Menu, NgClass, FloatingElementDirective],
  templateUrl: './table-overlay-column-assignment-item.component.html',
})
export class TableOverlayColumnAssignmentItemComponent {
  @Input({ required: true }) tableData!: TableData;
  @Input({ required: true }) columnIndex!: number;
  @Input({ required: true }) columnWidth!: number;

  readonly isMenuOpened = model<boolean>(false);

  readonly tableColumnLabelsByKeys = input.required<Partial<Record<string, string>>>();

  @Output() columnButtonClicked = new EventEmitter<number>();
  @Output() newTableHeaderAtColumnPosition = new EventEmitter<{
    columnKey: FieldModelKey;
  }>();

  protected readonly NOT_IMPORTANT_TABLE_HEADER = NOT_IMPORTANT_TABLE_HEADER;

  protected readonly menuItems = computed(() => this.getMenuItems(this.tableColumnLabelsByKeys()));

  private getMenuItems(labelsByKeys: Partial<Record<string, string>>): MenuItem[] {
    return [
      {
        label: 'Spalte',
        items: entries(labelsByKeys)
          .concat([[NOT_IMPORTANT_TABLE_HEADER, 'Unwichtig']])
          .map(([key, label]) => {
            return {
              label,
              command: (event) => this.setColumnHeader(key, event),
            };
          }),
      },
    ];
  }

  protected setColumnHeader(header: string, event: MenuItemCommandEvent) {
    event.originalEvent?.stopPropagation();
    this.newTableHeaderAtColumnPosition.emit({ columnKey: header });
  }
}
